import isNil from 'lodash/isNil';

/**
 * Converts `value` number to a percent % string. An empty string
 * is returned for `null` and `undefined` values.
 * @since 1.5.0
 * @category Function
 * @param {number} value The value to convert.
 * @param {number} [precision] The value specified number of decimals.
 * @returns {string} Returns the converted string.
 * @example
 *
 * toPercent()
 * // => ''
 *
 * toPercent(null)
 * // => ''
 *
 * toPercent(0.710476)
 * // => '71%'
 *
 * toPercent(0.7154, 1)
 * // => '71.5%'
 */

function toPercent(value, precision = 0) {
  if (isNil(value)) {
    return '';
  }

  if (typeof value === 'string') {
    return value;
  }

  return `${(value * 100).toFixed(precision)}%`;
}

export default toPercent;
